<div class="days-scale">
  @for (amount of [30, 60, 90, 120]; track amount) {
    <div class="section"></div>
    <div
      matRipple
      class="dot"
      [matRippleCentered]="true"
      [attr.data-days]="amount"
      [ngClass]="{ 'filled-dot': daysAmount >= amount, empty: daysAmount < amount }"
      (click)="updateDaysAmount(amount)"
    ></div>
  }

  <div class="days-progress-bar">
    <div
      class="filled"
      [ngStyle]="{ width: calculateProgressWidth(true, daysAmount) + '%' }"
    ></div>
    <div
      class="empty"
      [ngStyle]="{ width: calculateProgressWidth(false, daysAmount) + '%' }"
    ></div>
  </div>
</div>
